import React from 'react';
import { createRoot } from 'react-dom/client';
import TickerApp from './ticker/app';
const rootElement = document.getElementById('ticker');
if(rootElement){
    const league_id = rootElement.dataset.leagueid
    const root = createRoot(rootElement);
    root.render(
        <TickerApp 
            league_id={league_id ?? '8'}
        />
    )
}
